namespace GpScot.SearchFilterSectionExpander {

    enum FilterPanelClasses {
        FilterCollapser = 'js-filters-dropdown-collapser',
        FilterTitle = 'js-filters-title',
        Filter = 'nhssf-filters-component-dropdown',
        FilterToggleOff = 'js-filters-section-toggle--closed',
        IconTouch = 'js-icon-touch',
    }

    enum MobileFilterMessageClasses {

        FilterCollapser = 'js-filters-list-collapser',
        FilterToggleOff = 'js-filters-list-toggle--closed',
        FilterFieldset = 'nhssf-search-filters-item'
    }

    enum HiddenFilterItemClasses {
        Filter = 'nhssf-search-filters-item',
        FilterHint = 'nhsuk-hint',
        FilterToggle = 'js-filters-toggle',
        FilterToggleOff = 'js-filters-toggle--off',
        RadioList = 'nhsuk-filters',
        RadioListItem = 'nhsuk-filters__item',
        HideRadioItem = 'nhsuk-filters__item--hidden'
    }

    enum FilterPanelIcons {
        FiltersViewMore = 'M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z',
        FiltersViewLess = 'M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z'
    }

    enum MobileFilterMessages {
        ViewMore = 'Show filters',
        Viewless = 'Hide filters'
    }

    enum HiddenFilterMessages {
        ShowMore = 'Show all',
        ShowLess = 'Show less'
    }

    export function init() {
        initPanelToggle();
        initMobileMessageToggle();
        initHiddenFiltersToggle();
    }

    const initPanelToggle = () => {
        const collapserSvgs = Array.from(document.querySelectorAll(`.${FilterPanelClasses.FilterCollapser}`));

        collapserSvgs.forEach(svg => {
            svg.addEventListener('click', () => {
                const isClosed = svg.classList.contains(FilterPanelClasses.FilterToggleOff);
                svg.classList.toggle(FilterPanelClasses.FilterToggleOff, !isClosed);
                const pathElement = svg.querySelector(`path.${FilterPanelClasses.IconTouch}`);
                // Not sure why the path element needs to toggle the closed class
                // as its path attribute is updated depending on whether it's open
                // or closed, but doing it to be consistent with live.
                pathElement?.classList.toggle(FilterPanelClasses.FilterToggleOff, !isClosed);
                pathElement?.setAttribute('d', isClosed ? FilterPanelIcons.FiltersViewLess : FilterPanelIcons.FiltersViewMore);
                // Toggle the closed class on the grandparent of the SVG (a div with the CLASSES.Filter class)
                // This causes the filter panel to show and hide
                svg.closest(`.${FilterPanelClasses.Filter}`)?.classList.toggle(FilterPanelClasses.FilterToggleOff, !isClosed);
                // div* > h3 > svg* > path* (*toggles the closed class)
            });
        });
    }

    const initMobileMessageToggle = () => {
        document
            .querySelectorAll(`span.${MobileFilterMessageClasses.FilterCollapser}`)
            .forEach(span => {
                span.addEventListener('click', () => {

                    const isClosed = span.classList.contains(MobileFilterMessageClasses.FilterToggleOff);

                    span.classList.toggle(MobileFilterMessageClasses.FilterToggleOff, !isClosed);
                    span.innerHTML = isClosed ? MobileFilterMessages.Viewless : MobileFilterMessages.ViewMore;
                    span.closest(`.${MobileFilterMessageClasses.FilterFieldset}`)?.classList.toggle(MobileFilterMessageClasses.FilterToggleOff, !isClosed);
                });
            });
    }

    const initHiddenFiltersToggle = () => {

        const filterLists = document.querySelectorAll(`.${HiddenFilterItemClasses.Filter} > .${HiddenFilterItemClasses.RadioList}`);

        filterLists.forEach(listWrapper => {

            const hintElement = listWrapper.closest(`.${HiddenFilterItemClasses.Filter}`)?.querySelector(`.${HiddenFilterItemClasses.FilterHint}`);

            const filterItems = Array.from(listWrapper.querySelectorAll(`.${HiddenFilterItemClasses.RadioListItem}`));

            const itemThreshold = 5;

            if (filterItems.length > itemThreshold) {
                hintElement.innerHTML += `<span data-counters="${filterItems.length}" class="${HiddenFilterItemClasses.FilterToggle}">${HiddenFilterMessages.ShowMore}</span>`;
                hintElement.classList.add(HiddenFilterItemClasses.FilterToggleOff);
            }

            hintElement
                ?.querySelector(`.${HiddenFilterItemClasses.FilterToggle}`)
                ?.addEventListener('click', () => {

                    const isClosed = hintElement.classList.contains(HiddenFilterItemClasses.FilterToggleOff);

                    hintElement.classList.toggle(HiddenFilterItemClasses.FilterToggleOff, !isClosed);

                    filterItems.forEach((item, index) => {
                        console.log(index);

                        const forceClass = index >= itemThreshold && !isClosed;
                        item.classList.toggle(HiddenFilterItemClasses.HideRadioItem, forceClass);
                    });

                    const messageElement = hintElement.querySelector(`.${HiddenFilterItemClasses.FilterToggle}`);

                    messageElement.innerHTML = !isClosed ? HiddenFilterMessages.ShowMore : HiddenFilterMessages.ShowLess;
                });
        })
    }

}

// **** Original from NHS - kept as reference for now ****


//class SearchFiltersSectionExpander {
//  constructor() {
//      enum CLASSES {
//          FilterCollapser = 'js-filters-dropdown-collapser',
//          FilterTitle = 'js-filters-title',
//          Filter = 'nhssf-filters-component-dropdown',
//          Legend = 'nhsuk-fieldset__legend',
//          FilterToggle = 'js-filters-section-toggle',
//          FilterToggleOff = 'js-filters-section-toggle--closed',
//          FilterContents = 'js-nhssf-filters-component-dropdown',
//          IconTouch = 'js-icon-touch',
//      }

//      enum ICONS {
//          FiltersViewMore = `M207.029 381.476L12.686 187.132c - 9.373 - 9.373 - 9.373 - 24.569 0 - 33.941l22.667 - 22.667c9.357 - 9.357 24.522 - 9.375 33.901 - .04L224 284.505l154.745 - 154.021c9.379 - 9.335 24.544 - 9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c - 9.373 9.372 - 24.569 9.372 - 33.942 0z`,
//          FiltersViewLess = `M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l - 22.667 22.667c - 9.357 9.357 - 24.522 9.375 - 33.901.04L224 227.495 69.255 381.516c - 9.379 9.335 - 24.544 9.317 - 33.901 - .04l - 22.667 - 22.667c - 9.373 - 9.373 - 9.373 - 24.569 0 - 33.941L207.03 130.525c9.372 - 9.373 24.568 - 9.373 33.941 - .001z`,
//      }

//    let filterListText = document.querySelectorAll('.' + CLASSES.FilterTitle);

//    const OnClick = () => {
//      document.body.addEventListener('click', (e) => {
//          // If icon parent is touched
//          const targetElement = e.target as HTMLElement;
//        if (
//          matches(e.target, '.' + CLASSES.FilterCollapser) &&
//          matches(e.target, '.' + CLASSES.FilterToggleOff)
//        ) {
//          e.target.childNodes[0].setAttribute('d', ICONS.FiltersViewLess);
//          e.target.classList.remove(CLASSES.FilterToggleOff);
//          e.target.parentNode.parentNode.classList.remove(CLASSES.FilterToggleOff);
//        } else if (matches(e.target, '.' + CLASSES.FilterCollapser)) {
//          e.target.childNodes[0].setAttribute('d', ICONS.FiltersViewMore)
//          e.target.classList.add(CLASSES.FilterToggleOff);
//          e.target.parentNode.parentNode.classList.add(CLASSES.FilterToggleOff);
//        }
//        // If icon is touched
//        if (
//          matches(e.target, '.' + CLASSES.IconTouch) &&
//          matches(e.target, '.' + CLASSES.FilterToggleOff)
//        ) {
//            const targetElement = e.target as HTMLElement;
//            targetElement.setAttribute('d', ICONS.FiltersViewLess);
//            targetElement.classList.remove(CLASSES.FilterToggleOff);
//            targetElement.parentNode.parentNode.classList.remove(CLASSES.FilterToggleOff);
//            targetElement.parentNode.parentNode.parentNode.classList.remove(CLASSES.FilterToggleOff);
//        } else if (matches(e.target, '.' + CLASSES.IconTouch)) {
//            targetElement.setAttribute('d', ICONS.FiltersViewMore);
//            targetElement.classList.add(CLASSES.FilterToggleOff);
//            targetElement.parentNode.parentNode.classList.add(CLASSES.FilterToggleOff);
//            targetElement.parentNode.parentNode.parentNode.classList.add(CLASSES.FilterToggleOff);
//        }
//      });
//    };

//    const init = () => {
//      Array.prototype.forEach.call(filterListText, function(el, i) {
//        el.innerHTML += `< svg xmlns = "http://www.w3.org/2000/svg" viewBox = "0 0 448 512" class="${CLASSES.FilterCollapser} ${CLASSES.FilterToggleOff}" > <path class="${CLASSES.IconTouch} ${CLASSES.FilterToggleOff}" d = "${ICONS.FiltersViewMore}" /> </svg>`;
//      });
//OnClick();
//    };

//!!document.querySelector('.' + CLASSES.FilterTitle) && init();
//  }
//}

//export default SearchFiltersSectionExpander;

//class SearchFiltersListExpander {
//    constructor() {
//        enum CLASSES {
//            FilterCollapser = 'js-filters-list-collapser',
//            Filter = 'nhssf-search-filters-item',
//            Legend = 'nhsuk-fieldset__legend',
//            FilterToggle = 'js-filters-list-toggle',
//            FilterToggleOff = 'js-filters-list-toggle--closed',
//        }

//        enum MESSAGES {
//            FiltersViewMore = 'Show filters',
//            FiltersViewLess = 'Hide filters',
//        }

//        let matches = function (el, selector) {
//            return (
//                el.matches ||
//                el.matchesSelector ||
//                el.msMatchesSelector ||
//                el.mozMatchesSelector ||
//                el.webkitMatchesSelector ||
//                el.oMatchesSelector
//            ).call(el, selector);
//        };

//        let filterListText = document.querySelectorAll(
//            '.' + CLASSES.Filter + ' > ' + '.' + CLASSES.Legend
//        );

//        const OnClick = () => {
//            document.body.addEventListener('click', (e) => {
//                if (
//                    matches(e.target, '.' + CLASSES.FilterCollapser) &&
//                    matches(e.target, '.' + CLASSES.FilterToggleOff)
//                ) {
//                    e.target.innerHTML = MESSAGES.FiltersViewLess;
//                    e.target.classList.remove(CLASSES.FilterToggleOff);
//                    e.target.parentNode.parentNode.classList.remove(
//                        CLASSES.FilterToggleOff
//                    );
//                } else if (matches(e.target, '.' + CLASSES.FilterCollapser)) {
//                    e.target.innerHTML = MESSAGES.FiltersViewMore;
//                    e.target.classList.add(CLASSES.FilterToggleOff);
//                    e.target.parentNode.parentNode.classList.add(CLASSES.FilterToggleOff);
//                }
//            });
//        };

//        const init = () => {
//            Array.prototype.forEach.call(filterListText, function (el, i) {
//                el.innerHTML += `<span class="${CLASSES.FilterCollapser} ${CLASSES.FilterToggleOff}">${MESSAGES.FiltersViewMore}</span>`;
//            });
//            OnClick();
//        };

//        !!document.querySelector('.' + CLASSES.Filter) && init();
//    }
//}

//export default SearchFiltersListExpander;